import { useIdentityStore } from '@/stores/identityStore'
import { Routes } from '@/plugins/router/constants'
import type { NavigationGuard } from 'vue-router'

export const queryStringRouteGuard: NavigationGuard = (to, _, next) => {
  const identityStore = useIdentityStore()

  if (typeof to.query.redirect_url === 'string') {
    identityStore.setRedirectUrl(to.query.redirect_url)
  } else if (to.name === Routes.Login || to.name === Routes.Logout || to.name === Routes.SignoutCallback) {
    identityStore.clearRedirectUrl()
  }

  next()
}
